import { LazyMotion, MotionConfig, domAnimation, m } from "motion/react"

export default ({ toggle, toggled }) => {
    return (
        <LazyMotion features={domAnimation} strict>
            <MotionConfig
                transition={{
                    duration: 0.3,
                    ease: "easeInOut",
                }}
            >
                <m.button
                    initial={false}
                    animate={toggled ? "open" : "closed"}
                    onClick={() => toggle()}
                    className="relative h-20 w-20 rounded-full bg-white/0"
                >
                    <m.span
                        variants={VARIANTS.top}
                        className="absolute h-1 w-8 bg-white rounded-sm"
                        style={{
                            y: "-50%",
                            left: "calc(50% + 4px)",
                            x: "-50%",
                            top: "35%",
                        }}
                    />
                    <m.span
                        variants={VARIANTS.middle}
                        className="absolute h-1 w-10 bg-white rounded-sm"
                        style={{
                            left: "50%",
                            x: "-50%",
                            top: "50%",
                            y: "-50%",
                        }}
                    />
                    <m.span
                        variants={VARIANTS.bottom}
                        className="absolute h-1 w-5 bg-white rounded-sm"
                        style={{
                            x: "-50%",
                            y: "50%",
                            bottom: "35%",
                            left: "calc(50% + 10px)",
                        }}
                    />
                </m.button>
            </MotionConfig>
        </LazyMotion>
    )
}

const VARIANTS = {
    top: {
        open: {
            rotate: ["0deg", "0deg", "45deg"],
            top: ["35%", "50%", "50%"],
            left: "50%",
            width: "40px",
        },
        closed: {
            rotate: ["45deg", "0deg", "0deg"],
            top: ["50%", "50%", "35%"],
            left: "calc(50% + 4px)",
            width: "32px",
        },
    },
    middle: {
        open: {
            rotate: ["0deg", "0deg", "-45deg"],
        },
        closed: {
            rotate: ["-45deg", "0deg", "0deg"],
        },
    },
    bottom: {
        open: {
            rotate: ["0deg", "0deg", "45deg"],
            bottom: ["35%", "50%", "50%"],
            left: "50%",
        },
        closed: {
            rotate: ["45deg", "0deg", "0deg"],
            bottom: ["50%", "50%", "35%"],
            left: "calc(50% + 10px)",
        },
    },
}
